module.exports = __webpack_public_path__ + "img/full.426b5f09.png";